import { render, staticRenderFns } from "./Referents.vue?vue&type=template&id=77eba121&"
import script from "./Referents.vue?vue&type=script&lang=js&"
export * from "./Referents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports